import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import Schedule from './forms/schedule'
import EditGame from './forms/edit-game'

const Games = props => {
  const {league, games, schedule} = props
  const [modalMode, setModalMode] = useState(false)
  const [scheduleOpen, setScheduleOpen] = useState(false)
  const [editGame, setEditGame] = useState(null)
  const [formChanged, setFormChanged] = useState(false)
  const nextForm = useRef()
  const formRef = useRef()
  const rounds = _.groupBy(games, (game) => game.round)

  useEffect(() => {
    setModalMode(window.innerWidth < 1400)
    window.addEventListener('resize', handleResize)
  }, [])

  const handleResize = () => {
    setModalMode(window.innerWidth < 1400)
  }

  const onEditGame = (game) => {
    if (!formChanged) return switchGame(game)

    if (window.confirm('There are unsaved changes. Do you want to save game before continue?')) {
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
      nextForm.current = game
    }
  }

  const onUpdateGame = (game) => {
    props.onUpdateGame(game)
    nextForm.current ? switchGame(nextForm.current) : switchGame(null)
  }

  const imageUrl = (team) => {
    return team.photo || '/images/leagues/team.png'
  }

  const switchGame = (game) => {
    props.onShorten(!!game)
    setEditGame(game)
    setFormChanged(false)
    nextForm.current = null
  }

  const gameRowClass = (game) => {
    if (editGame && game.id == editGame.id) return 'selected'

    return ''
  }

  const gamesList = (roundGames) => {
    return roundGames.map((game, i) => {
      return <tr className={gameRowClass(game)} key={i} onClick={() => onEditGame(game)}>
        <td>{game.date}</td>
        <td>{game.time}</td>
        <td>
          <div className='team-title reverse'>
            <img src={imageUrl(game.team1)} />
            <span>{game.team1.name}</span>
          </div>
        </td>
        <td><span className='game-score'>{`${game.team1_score} - ${game.team2_score}`}</span></td>
        <td>
          <div className='team-title'>
            <img src={imageUrl(game.team2)} />
            <span>{game.team2.name}</span>
          </div>
        </td>
        <td><span className='game-time'>Full Time</span></td>
        <td><button className='game-edit-button'></button></td>
      </tr>
    })
  }

  const gamesTable = (round, roundGames) => {
    return <div className='games-round' key={round}>
      <div className='round-title'>{`Round ${round}`}</div>
      <table className='games-table'>
        <thead>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>TEAM 1</th>
            <th>SCORE</th>
            <th>TEAM 2</th>
            <th>TIME</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {gamesList(roundGames)}
        </tbody>
      </table>
    </div>
  }

  const roundsList = () => {
    return _.map(rounds, (rGames, round) => {
      return gamesTable(round, rGames)
    })
  }

  return <div className='league-games-wrapper'>
    <div id='league-games'>
      { !schedule && <div>
          <div className='league-no-schedule'>There is no schedule set for the league yet. Please create a new one</div>
          <button className='league-schedule' onClick={() => setScheduleOpen(true)}>
            Create New Schedule
          </button>
        </div>
      }
      { schedule &&
        <button className='league-schedule' onClick={() => setScheduleOpen(true)}>
          Edit Schedule
        </button>
      }
      { games.length > 0 &&
        <div className={'league-games-wrap' + (props.shortened ? ' shortened' : '')}>
          {roundsList()}
        </div>
      }
      { scheduleOpen && 
        <Schedule
          league={league}
          schedule={schedule}
          onCreateSchedule={props.onCreateSchedule}
          onCreateGames={props.onCreateGames}
          onHide={() => setScheduleOpen(false)}
        />
      }
    </div>
    { editGame && !modalMode &&
      <div className='edit-game-wrapper'>
        <EditGame
          league={league}
          game={editGame}
          onClose={() => switchGame(null)}
          formRef={formRef}
          onUpdate={onUpdateGame}
          onChanged={value => setFormChanged(value)}
        />
      </div>
    }
    { editGame && modalMode &&
      <Modal show={true} container={document.body} backdrop='static' dialogClassName='edit-game-modal' onHide={() => onEditGame(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Game Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditGame
            league={league}
            game={editGame}
            onClose={() => switchGame(null)}
            formRef={formRef}
            onUpdate={onUpdateGame}
            onChanged={value => setFormChanged(value)}
          />
        </Modal.Body>
      </Modal>
    }
  </div>
}

Games.propTypes = {
  league: PropTypes.object.isRequired,
  games: PropTypes.array,
  schedule: PropTypes.object,
  shortened: PropTypes.bool,
  onCreateSchedule: PropTypes.func.isRequired,
  onCreateGames: PropTypes.func.isRequired,
  onUpdateGame: PropTypes.func.isRequired,
  onShorten: PropTypes.func.isRequired,
}

export default Games
